// src/screens/sales/saleItem/SaleItem.tsx

import React from 'react'
import classes from './SaleItem.module.sass'
import { Helmet } from 'react-helmet-async'
import { List } from './components/list/List'
import { Button } from '../../../common/components/button/Button'
import { useSaleItem } from './hooks/useSaleItem'
import { Modal } from '../../../common/components/modal/Modal'
import { Form } from './components/form/Form'
import Qr from '../../../common/components/qr/Qr'
import { Details } from './components/details/Details'
import Search from '../../../common/components/listControl/search/Search'

export const SaleItem = () => {
  const {
    getList,
    modalActive,
    setModalActive,
    startCreate,
    edit,
    startEdit,
    data,
    setData,
    list,
    detailsModalActive,
    setDetailsModalActive,
    showDetails,
    current,
    qrAction,
    loading,
    searchQuery,
    handleSearch,
    clearSearch,
    startDuplicate,
  } = useSaleItem()

  return (
    <div className={classes.container}>
      <Helmet>
        <title>{`Справочник товаров`}</title>
        <meta name="description" content={`Справочник товаров`} />
      </Helmet>
      <div className={classes.titleWithButtons}>
        <div className={classes.header}>{`товары`}</div>
        <Button onClick={startCreate} text="Создать" />
        <Qr onChange={qrAction} />
      </div>

      <div className={classes.searchContainer}>
        <Search
          onChange={handleSearch}
          clear={clearSearch}
          value={searchQuery}
          placeHolder="Поиск по id, названию или описанию"
        />
      </div>

      <List
        startEdit={startEdit}
        list={list}
        showDetails={showDetails}
        loading={loading}
        startDuplicate={startDuplicate}
      />

      <Modal modalActive={modalActive} setModalActive={setModalActive}>
        <Form
          edit={edit}
          data={data}
          setData={setData}
          getList={getList}
          setModalActive={setModalActive}
          el={current}
        />
      </Modal>

      <Modal modalActive={detailsModalActive} setModalActive={setDetailsModalActive}>
        <Details el={current} />
      </Modal>
    </div>
  )
}
